
import Vue from 'vue'
import axios from 'axios'
import { Notification } from '@/domains/global/models'
import NotificationDisplay from './Notification.vue'

const MAX_NOTIFICATIONS = 10

type ListResponse<T> = {
  data: T[];
  total: number;
}

export default Vue.extend({
  components: { NotificationDisplay },
  data() {
    return {
      isLoading: true,
      isOpen: false,
      notifications: [] as Notification[],
      unreadCount: 0
    }
  },
  mounted() {
    this.fetchNotifications()
    this.$socket().on('notification', this.onNewNotification)
  },
  beforeDestroy() {
    this.$socket().off('notification', this.onNewNotification)
  },
  methods: {
    async fetchNotifications() {
      this.isLoading = true
      try {
        const response = await axios.get<ListResponse<Notification>>('/notifications?count=10&orderBy[DESC]=created')
        this.notifications = response.data.data
        this.unreadCount = this.notifications.reduce((count, notification) => {
          return count + (notification.isRead ? 0 : 1)
        }, 0)
      } finally {
        this.isLoading = false
      }
    },
    onNewNotification(notification: Notification) {
      const newLength = this.notifications.unshift(notification)
      if (newLength > MAX_NOTIFICATIONS) {
        this.notifications.pop()
      }
      this.unreadCount++
    },
    onMenuChange(isOpeningMenu: boolean) {
      if (isOpeningMenu) {
        this.unreadCount = 0

        this.$socket().emit('notifications:read')
      }
    }
  }
})
